// extracted by mini-css-extract-plugin
export default {"card":"index_card__zs5o0","title":"index_title__9oHc1","topic":"index_topic__id0cr","content":"index_content__3mMXH","value":"index_value__+not+"};